export default  {"src":"/_next/static/image/public/images/icon_sm_home.d99d3786ce9b4bf35d4d4808e50b8c5d.svg","height":20,"width":22};